/**
 * GENERATED BY KRPC GEN - LESS MODIFY BY HAND
 * invite-service.ts  2026-01-21T16:22:03+08:00
 */
import type { R, RpcService, MethodConfig as M } from 'krpc-base'

import type { InviteBindReq, InviteBindRes } from './wy-dto'

const _ = 'Invite/'

export class InviteService {
  constructor(readonly r: RpcService) {}
  // 绑定邀请关系
  bindRelation(d: InviteBindReq, m?: M): R<InviteBindRes> {
    return this.r.async(_ + 'bindRelation', d, m)
  }
  // 被邀请用户未完成首单，短信提醒
  remind(d: number, m?: M): R<boolean> {
    return this.r.async(_ + 'remind', d, m)
  }
}
